import React, { FC } from 'react'
import Navbar from 'components/Navbar'
import { useVersioning } from 'modules/versioning'
import { Link, useHistory, useParams } from 'react-router-dom'
import Zoom, { ZoomTypes, ZoomProps } from 'components/Zoom'
import { ReactComponent as CrossIcon } from 'icons/cross-20.svg'
import { ReactComponent as PlayIcon } from 'icons/play-20.svg'
import ArtboardPaginationControls from '../ArtboardPaginationControls'
import { RouteParams } from 'constants/routes'
import { Pagination } from 'modules/shares/types'

const UntypedArtboardPaginationControls = ArtboardPaginationControls as any

type EmbeddedDetailHeaderProps = {
  artboardName: string
  pagination?: Pagination
  showPrototypePlayButton: boolean
  onZoomChanged: ZoomProps['onZoomChanged']
  currentZoom: ZoomTypes
}

const EmbeddedDetailHeader: FC<EmbeddedDetailHeaderProps> = ({
  artboardName,
  showPrototypePlayButton,
  pagination,
  currentZoom,
  onZoomChanged,
}) => {
  const history = useHistory()
  const { getPathname } = useVersioning()
  const { shareID, permanentArtboardShortId } = useParams<
    RouteParams<'ARTBOARD_DETAIL'>
  >()

  const backPath = getPathname({
    routeKey: 'SHARE_VIEW',
    routeParams: { shareID },
  })

  const prototypePath = getPathname({
    routeKey: 'PROTOTYPE',
    routeParams: { shareID, permanentArtboardShortId },
  })

  return (
    <Navbar>
      <>
        <Navbar.Section>
          <Navbar.Button
            data-testid="embedded-detail-header-close-button"
            icon={CrossIcon}
            onClick={() => history.push(backPath)}
          />
          {pagination && (
            <>
              <Navbar.Divider />
              <UntypedArtboardPaginationControls
                current={pagination.current}
                total={pagination.total}
                showNumbers
              />
            </>
          )}
        </Navbar.Section>

        <Navbar.Title>{artboardName}</Navbar.Title>

        <Navbar.Section align="end">
          {showPrototypePlayButton && (
            <Link to={prototypePath} title="Play prototype">
              <Navbar.Button icon={PlayIcon} />
            </Link>
          )}
          <Zoom zoom={currentZoom} onZoomChanged={onZoomChanged} />
        </Navbar.Section>
      </>
    </Navbar>
  )
}

export { EmbeddedDetailHeader }
